<template>
  <div>
    <EsHeaderView />
    <div class="container-box">
      <div class="app-container">
        <div class="page-title">{{ $t('message.home.couponCenter') }}</div>
        <div v-loading="loading">
          <div class="coupon-grid" v-if="list.length">
            <div class="coupon-card" :class="{ 'coupon-card--claimed': item.code }" v-for="item in list" :key="item.id">
              <div class="coupon-left">
                <div class="amount">¥{{ item.priceExpression }}</div>
                <div class="threshold" v-if="item.minimumPrice">{{ $t('message.home.minSpend') }}¥{{ item.minimumPrice }}</div>
              </div>
              <div class="coupon-notch"></div>
              <div class="coupon-right">
                <div class="coupon-name">{{ item.name }}</div>
                <div class="coupon-date">{{ item.beginDate }} ~ {{ item.endDate }}</div>
                <el-button v-if="!item.code" size="mini" type="danger" :loading="item.receiving" @click="receiveCoupon(item)">
                  {{ $t('message.home.getCoupon') }}
                </el-button>
                <el-button v-else size="mini" type="info" disabled plain>
                  {{ $t('message.home.couponReceived') }}
                </el-button>
              </div>
              <div class="coupon-stamp" v-if="item.code">{{ $t('message.home.couponReceived') }}</div>
            </div>
          </div>
          <el-empty v-if="!list.length && !loading" :description="$t('message.home.noData')" />
          <div class="common-pagination" v-if="total > 0">
            <el-pagination background layout="prev,pager,next,total" :page-size="queryParams.pageSize"
              :current-page="queryParams.pageNumber" :total="total" @current-change="currentChange" />
          </div>
        </div>
      </div>
    </div>
    <EsFooterView />
  </div>
</template>

<script>
import { findCouponEnable } from "@/api/marketing/coupon";
import { getCoupon } from "@/api/marketing/coupon_code";
import { isShopLoggedIn } from "@/util/shopAuth";

export default {
  name: "CouponCenter",
  data() {
    return { loading: false, list: [], total: 0,
      queryParams: { pageNumber: 1, pageSize: 20 } }
  },
  created() { this.loadData() },
  methods: {
    loadData() {
      this.loading = true
      findCouponEnable({ ...this.queryParams, quantity: 0 }).then(r => {
        const data = r.data?.data
        const arr = Array.isArray(data) ? data : (data?.content || [])
        this.list = arr.map(item => ({ ...item, receiving: false }))
        this.total = Array.isArray(data) ? data.length : (data?.total || 0)
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    currentChange(page) { this.queryParams.pageNumber = page; this.loadData() },
    receiveCoupon(item) {
      if (item.code) { return }
      if (!isShopLoggedIn(this)) {
        this.$router.push({ path: '/login', query: { redirect: this.$route.fullPath } })
        return
      }
      item.receiving = true
      getCoupon({ id: item.id }).then(r => {
        item.receiving = false
        if (r.data?.message === 'SUCCESS' || r.data?.code === 0) {
          item.code = (r.data?.data?.couponCode && r.data.data.couponCode.code) || 'RECEIVED'
          this.$message.success(this.$t('message.home.getCouponSuccess'))
        } else {
          this.$message.warning(r.data?.message || this.$t('message.home.fail'))
        }
      }).catch(() => { item.receiving = false })
    }
  }
}
</script>

<style lang="scss" scoped>
.container-box { background: #f5f5f5; min-height: calc(100vh - 120px); }
.app-container { width: 1200px; margin: 0 auto; padding: 30px 0; }
.page-title { font-size: 22px; font-weight: bold; margin-bottom: 20px; }
.coupon-grid { display: flex; flex-wrap: wrap; gap: 16px; }
.coupon-card {
  display: flex; position: relative; border-radius: 8px; overflow: hidden;
  box-shadow: 0 2px 8px rgba(255, 107, 53, .15);
  background: #fff; width: calc(50% - 8px); transition: box-shadow .2s, transform .2s;
  &:hover { box-shadow: 0 4px 14px rgba(255, 107, 53, .28); transform: translateY(-2px); }
}
.coupon-left {
  background: linear-gradient(135deg, #ff6b35, #ff3d3d); color: #fff; padding: 20px;
  min-width: 110px; display: flex; flex-direction: column; align-items: center; justify-content: center;
}
.amount { font-size: 26px; font-weight: bold; }
.threshold { font-size: 11px; opacity: .85; margin-top: 4px; text-align: center; }
/* 优惠券撕口：用背景色圆点在左右两块之间打孔，模拟券的撕边 */
.coupon-notch {
  position: relative; width: 0;
  &::before, &::after {
    content: ''; position: absolute; width: 14px; height: 14px; border-radius: 50%;
    background: #f5f5f5; left: -7px;
  }
  &::before { top: -7px; }
  &::after { bottom: -7px; }
}
.coupon-right { flex: 1; padding: 16px; display: flex; flex-direction: column; }
.coupon-name { font-size: 14px; font-weight: bold; color: #303133; margin-bottom: 6px; }
.coupon-date { font-size: 12px; color: #909399; margin-bottom: 10px; }
.coupon-right .el-button { align-self: flex-start; }
.coupon-stamp {
  position: absolute; top: 10px; right: -28px; width: 110px; text-align: center;
  background: rgba(144, 147, 153, .85); color: #fff; font-size: 11px; padding: 2px 0;
  transform: rotate(35deg); letter-spacing: 1px;
}
.coupon-card--claimed {
  box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
  &:hover { box-shadow: 0 2px 8px rgba(0, 0, 0, .06); transform: none; }
  .coupon-left { background: linear-gradient(135deg, #bdbdbd, #9e9e9e); }
  .coupon-name, .coupon-date { color: #c0c4cc; }
}
.common-pagination { margin-top: 24px; text-align: center; }
</style>
